import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction26, obtenerDatosSolicitud } from '../../store/actions/solicitud-descuento-action'
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import SolicitudDescuento from './solicitudDescuento'
import { LoadingComponent } from 'recupero-comunes'

const SolicitudDescuentoModal = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso }) => {
    const [loading,setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
   const dispatch=useDispatch()
    
    useEffect(() => {     

         dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
        if(llaves){ 
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 26
        })).toString('base64')
        dispatch(configuracionFormAction26(query))
    .then(()=>{
        let query = Buffer.from(JSON.stringify({
            "idImplicado": llaves && llaves['idImplicado'],
            "idCaso": llaves && llaves['idCaso']
        })).toString('base64')
        dispatch(obtenerDatosSolicitud(query))
    })
    .then(()=>{
        setLoading(false)
    })
    }
    }, [dispatch,llaves])
    return (
        <>
        <LoadingComponent show={loading}/>
            <SolicitudDescuento 
                handleClose={handleClose}
                />
        </>
    )
}

export default SolicitudDescuentoModal
